import React, { useState } from "react";
import "./aboutCompany.scss";
import upArrow from "../../assets/images/arrows/ic_chevron_accordian_up.svg";
import downArrow from "../../assets/images/arrows/ic_chevron_accordian_down.svg";

const AboutCompany = () => {
  const accordionState = false;
  const [accordionOpen, setAccordionOpen] = useState(
    accordionState
  );
  const toggleAccordion = e => {
    const sibling =
      e.target.parentElement.nextElementSibling ||
      e.target.parentElement.parentElement
        .nextElementSibling;
    if (sibling) {
      if (accordionOpen) {
        sibling.style.height = 0;
      } else {
        sibling.style.height =
          sibling.scrollHeight + 14 + "px";
      }
    }
    setAccordionOpen(!accordionOpen);
  };

  return (
    <>
      <div className="accordionDefault">
        <div className="accordion">
          <div
            className="accordion-heading"
            onClick={toggleAccordion}
          >
            <h3>About Share.Market</h3>
            {accordionOpen ? (
              <img
                className="accordion-arrow"
                src={upArrow}
              />
            ) : (
              <img
                className="accordion-arrow"
                src={downArrow}
              />
            )}
          </div>
        </div>
        <div className="accordion-panel">
          <p className="about-company-text">
            PhonePe&apos;s Share.Market is India&apos;s new
            stock market investment app. One can now invest
            in Indian stocks, ETFs, WealthBaskets, Mutual
            Funds and more.
          </p>

          <p className="about-company-text">
            Share.Market is here to change the way India
            invests in the share market by offering seamless
            and cutting-edge technology. It emerges as an
            unparalleled wealth, trading and investment app
            & website, catering to traders and investors of
            all expertise levels.
          </p>

          <p className="about-company-text">
            Experience a groundbreaking level of
            convenience, seamlessness, and agility with our
            investment solutions at a large scale. What
            truly distinguishes us is our unwavering
            commitment to delivering value-rich insights and
            intelligence, supplemented by comprehensive
            research services.
          </p>

          <p className="about-company-text">
            Introducing WealthBasket - A WealthBasket is a
            collection of stocks or ETFs, based on a
            strategy, theme, or research. They are curated
            by WealthBasket curators who are SEBI-registered
            Investment Advisors or Research Analysts.
          </p>

          <p className="about-company-text">
            Avail ZERO Brokerage on all WealthBaskets till
            31st March 2024. Start investing with
            WealthBaskets today! View the pricing page for
            more details.
          </p>

          <p className="about-company-text">
            <b>
              Open your FREE demat and trading account
              today!
            </b>
          </p>

          <p className="about-company-text">
            PhonePe Wealth Broking Private Limited, a
            subsidiary of PhonePe Private Limited is
            registered with NSE and BSE as a Stock Broker,
            with CDSL as a Depository Participant and with
            AMFI as a Mutual Fund distributor.
          </p>
        </div>
      </div>
    </>
  );
};

export default AboutCompany;
